export const PERSON_CONDITIONS = [
  // phenotype conditions
  {
    label: 'Endometriosis',
    id: 'HP:0030127',
    type: 'phenotype',
  },
  {
    label: 'Chronic pancreatitis that lasted longer than 6 months',
    id: 'HP:0006280',
    type: 'phenotype',
  },
  {
    label: 'Tumours or growths',
    id: 'tumour',
    type: 'phenotype',
  },
  {
    label: 'Tumour or growth in the pituitary, parathyroid or adrenal gland',
    id: 'pituitary',
    type: 'phenotype',
  },
  {
    label: 'More than 50 moles (not freckles)',
    id: 'moleNevi',
    type: 'phenotype',
  },
  {
    label: 'More than 5 polyps removed from the bowel (colon or rectum)',
    id: 'polypsRemoved',
    type: 'phenotype',
  },
  {
    label: 'Had a blood clot',
    id: 'bloodClot',
    type: 'phenotype',
  },
  {
    label: 'Lobular carcinoma in situ (LCIS)',
    id: 'HP:0030076',
    type: 'phenotype',
  },
  // heart symptoms
  {
    id: 'palpitations',
    label: 'Palpitations',
    type: 'heartSymptoms',
  },
  {
    id: 'dizziness',
    label: 'Dizziness',
    type: 'heartSymptoms',
  },
  {
    id: 'fainting',
    label: 'Fainting or loss of consciousness',
    type: 'heartSymptoms',
  },
  {
    id: 'chestPain',
    label: 'Chest pain',
    type: 'heartSymptoms',
  },
  {
    id: 'breathlessness',
    label: 'Breathlessness',
    type: 'heartSymptoms',
  },
  // heart problems
  {
    id: 'heartProblems',
    label: 'Heart problems',
  },
  // heart conditions
  {
    id: 'heartConditions',
    label: 'Heart Conditions',
  },
  {
    id: 'HP:0002617',
    label: 'Aneurysm',
    type: 'heartConditions',
  },
  {
    id: 'HP:0011675',
    label: 'Arrhythmia',
    type: 'heartConditions',
  },
  {
    id: 'arvc',
    label: 'Arrhythmogenic right ventricular cardiomyopathy (ARVC)',
    type: 'heartConditions',
  },
  {
    id: 'HP:0005110',
    label: 'Atrial fibrillation',
    type: 'heartConditions',
  },
  {
    id: 'brugada',
    label: 'Brugada syndrome',
    type: 'heartConditions',
  },
  {
    id: 'HP:0001638',
    label: 'Cardiomyopathy',
    type: 'heartConditions',
  },
  {
    id: 'HP:0030843',
    label: 'Cardiac amyloidosis',
    type: 'heartConditions',
  },
  {
    id: 'HP:0001695',
    label: 'Cardiac arrest',
    type: 'heartConditions',
  },
  {
    id: 'HP:0004758',
    label: 'Catecholaminergic polymorphic ventricular tachycardia (CPVT)',
    type: 'heartConditions',
  },
  {
    id: 'HP:0002625',
    label: 'Deep vein thrombosis (DVT)',
    type: 'heartConditions',
  },
  {
    id: 'HP:0001644',
    label: 'Dilated cardiomyopathy (DCM)',
    type: 'heartConditions',
  },
  {
    id: 'fabry',
    label: 'Fabry disease',
    type: 'heartConditions',
  },
  {
    id: 'fh',
    label: 'Familial hypercholesterolemia (FH)',
    type: 'heartConditions',
  },
  {
    id: 'HP:0001658',
    label: 'Heart attack or blockage of an artery',
    type: 'heartConditions',
  },
  {
    id: 'HP:0001627',
    label: 'Heart defect present at birth',
    type: 'heartConditions',
  },
  {
    id: 'HP:0001638',
    label: 'Heart disease',
    type: 'heartConditions',
  },
  {
    id: 'HP:0031653',
    label: 'Heart valve problems',
    type: 'heartConditions',
  },
  {
    id: 'HP:0001892',
    label: 'Hemophilia',
    type: 'heartConditions',
  },
  {
    id: 'HP:0000822',
    label: 'High blood pressure',
    type: 'heartConditions',
  },
  {
    id: 'HP:0003124',
    label: 'High cholesterol',
    type: 'heartConditions',
  },
  {
    id: 'HP:0001639',
    label: 'Hypertrophic cardiomyopathy (HCM)',
    type: 'heartConditions',
  },
  {
    id: 'loeysDietz',
    label: 'Loeys-Dietz syndrome',
    type: 'heartConditions',
  },
  {
    id: 'long',
    label: 'Long QT syndrome',
    type: 'heartConditions',
  },
  {
    id: 'marfan',
    label: 'Marfan syndrome',
    type: 'heartConditions',
  },
  {
    id: 'HP:0003560',
    label: 'Muscular dystrophy (e.g. Duchenne muscular dystrophy, Myotonic dystrophy)',
    type: 'heartConditions',
  },
  {
    id: 'HP:0002204',
    label: 'Pulmonary embolism (PE)',
    type: 'heartConditions',
  },
  {
    id: 'sickle',
    label: 'Sickle cell disease',
    type: 'heartConditions',
  },
  {
    id: 'thalassemia',
    label: 'Thalassemia',
    type: 'heartConditions',
  },
  {
    id: 'HP:0100724',
    label: 'Thrombophilia',
    type: 'heartConditions',
  },
  {
    id: 'HP:0001654',
    label: 'Valvular disease',
    type: 'heartConditions',
  },
  {
    id: 'vonWillebrand',
    label: 'Von Willebrand disease',
    type: 'heartConditions',
  },
  // relative heart conditions
  {
    id: 'epilepsy',
    label: 'Epilepsy or Seizures',
  },
  {
    id: 'hearingLoss',
    label: 'Hearing loss',
  },
]
